import { Controller } from "@hotwired/stimulus"

// Manage::BookingsController#show - Config tab
// Toggle de secciones condicionales (subscription max, date range)
export default class extends Controller {
  static targets = ["subscriptionMaxFields", "dateRangeCheckbox", "dateRangeSection", "specificDateSection", "recurrentSection", "publishRecordingSection", "publishRecordingFields", "newCollectionField"]

  toggleSubscriptionMax(event) {
    const checked = event.target.checked
    if (this.hasSubscriptionMaxFieldsTarget) {
      this.subscriptionMaxFieldsTarget.classList.toggle("hidden", !checked)
    }
  }

  toggleRecurrent(event) {
    const recurrent = event.target.value === "true"
    this.toggleSection(this.specificDateSectionTarget, !recurrent)
    this.toggleSection(this.recurrentSectionTarget, recurrent)

    // Disable hidden inputs to avoid duplicate name submissions
    this.specificDateSectionTarget.querySelectorAll("input").forEach(i => i.disabled = recurrent)
    if (this.hasDateRangeSectionTarget) {
      const rangeEnabled = this.dateRangeCheckboxTarget.checked
      this.dateRangeSectionTarget.querySelectorAll("input").forEach(i => i.disabled = !recurrent || !rangeEnabled)
    }
  }

  toggleDateRange() {
    const checked = this.dateRangeCheckboxTarget.checked
    this.toggleSection(this.dateRangeSectionTarget, checked)
    this.dateRangeSectionTarget.querySelectorAll("input").forEach(i => i.disabled = !checked)
  }

  toggleSection(target, show) {
    if (show) {
      target.classList.remove("hidden")
    } else {
      target.classList.add("hidden")
    }
  }

  toggleZoomAccount(event) {
    const hasValue = event.target.value !== ""
    if (this.hasPublishRecordingSectionTarget) {
      this.publishRecordingSectionTarget.classList.toggle("hidden", !hasValue)
    }
  }

  togglePublishRecording(event) {
    const checked = event.target.checked
    if (this.hasPublishRecordingFieldsTarget) {
      this.publishRecordingFieldsTarget.classList.toggle("hidden", !checked)
    }
  }

  toggleNewCollection(event) {
    const show = event.target.value === "new"
    if (this.hasNewCollectionFieldTarget) {
      this.newCollectionFieldTarget.classList.toggle("hidden", !show)
    }
  }
}
